import { createAllActions } from '@api/createRequestStore';
import * as types from './types';

const { init } = createAllActions(types.SCOPE);

const setMode = mode => ({
  type: types.SET_MODE,
  mode,
});

const setConfigSorting = sort => ({
  type: types.SET_CONFIG_SORTING,
  sort,
});

const setWarningContainerVisibility = visible => ({
  type: types.CHANGE_WARNING_CONTAINER_VISIBILITY,
  visible,
});

export {
  init,
  setMode,
  setConfigSorting,
  setWarningContainerVisibility,
};
